import React, { Suspense, useCallback, useMemo, useState } from 'react'
import { goToCalculatorLink } from '@blocks/BlockInvestCalculator'
import { ANALITYCS_InvestorFordStartInvestingButtonIds } from '@constants/analitycs-ids'
import { QsParams } from '@constants/query-fields'
import { PageSettings } from '@http/api-models/page-settings'
import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import PageAnimation from '@shared/components/page-animation'
import { ExternalPaths } from '@shared/menu-items/paths'
import { isProduction } from '@shared/pipes/config'
import { getMarketingData } from '@shared/pipes/marketing-data'
import dynamic from 'next/dynamic'

import { ModalSavings } from './ModalSavings/ModalSavings'
import { SectionAboutDeposit } from './SectionAboutDeposit'
import { goToConsultLink, SectionConsultNew } from './SectionConsultNew'
import { SectionDeposit } from './SectionDeposit'
import { SectionInvestors } from './SectionInvestors'
import { SectionMain } from './SectionMain'
import { SectionStart } from './SectionStart'
import { yaCounter } from '@shared/pipes/ya-counter'

const Calculator = dynamic(() =>
	import('./Calculator').then((data) => data.Calculator)
)

const getInvestorLkLink = () => {
	const marketingData = getMarketingData()
	const params = new URLSearchParams()

	if (marketingData?.qsParams) {
		Object.entries(marketingData.qsParams).forEach(([key, value]) => {
			params.set(key, String(value))
		})
	}

	const wcid = marketingData?.yandexClientId || ''
	if (wcid) {
		params.set('wcid', wcid)
	}
	if (marketingData?.entryUrl) {
		params.set('refLink', marketingData.entryUrl)
	}

	const baseUrl = isProduction ? ExternalPaths.investorLk : ExternalPaths.testInvestorLk
	const search = params.toString()
	return search ? `${baseUrl}?${search}` : baseUrl
}

export const openInvestorLkBlank = () => {
	window.open(getInvestorLkLink(), '_blank')
}

export interface InvestBusinessPageProps {
	pageSettings: PageSettings & {
		pledgeSummary?: PledgeSummaryResponse | undefined
	}
}

export const InvestBusiness = ({ pageSettings }: InvestBusinessPageProps) => {
	const [showModal, setShowModal] = useState(false)

	const onModalClose = useCallback(() => {
		setShowModal(false)
	}, [setShowModal])

	const { maxCashback, maxValue, minValue } = useMemo(() => {
		return (
			pageSettings?.savings?.params ||
			({
				maxCashback: '0',
				maxValue: '0',
				minValue: '0',
			} as any)
		)
	}, [pageSettings])

	return (
		<PageAnimation>
			<ModalSavings showModal={showModal} onModalClose={onModalClose} />
			<SectionMain
				maxCashback={maxCashback}
				buttonProps={{
					id: ANALITYCS_InvestorFordStartInvestingButtonIds(0),
					onClick: goToCalculatorLink,
				}}
			/>
			<SectionDeposit />
			<Suspense>
				<Calculator
					annualInterestRate={[minValue, maxValue]}
					onButtonClick={goToConsultLink}
				/>
			</Suspense>
			<SectionStart />
			<SectionAboutDeposit />
			<SectionInvestors />
			<SectionConsultNew />
		</PageAnimation>
	)
}
